import { render } from "./StoreSetupBanner.vue?vue&type=template&id=308d981d"
import script from "./StoreSetupBanner.vue?vue&type=script&lang=js"
export * from "./StoreSetupBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__